import { useField } from 'react-final-form'

const useFieldValue = name => {
  const { input } = useField(name, { subscription: { value: true } })
  return input.value
}

export default useFieldValue
